import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { UiInputGroupWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from "../../../../../_uiComponents/telerikComponents/UiInput";
import Stack from "@mui/material/Stack";
import { UiButton } from "../../../../../_uiComponents/common/form/UiButton";
import GamePlayRewardPotConfiguration from "./GamePlayRewardPotConfiguration";
import UiTopDropDownList from "../../../../../_uiComponents/telerikComponents/UiTopDropDownList";
import { UiRadioButton } from "../../../../../_uiComponents/telerikComponents/UiRadioButton";
import GameplayWheelConfigurationForm from "./forms/GameplayWheelConfigurationForm";
import RequiredClaimTokenCountForm from "./forms/RequiredClaimTokenCountForm";
import GamePlayConfigurationForm from "./forms/GamePlayConfigurationForm";
import GameplayWinningSlotConfigurationForm from "./forms/GameplayWinningSlotConfigurationForm";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { participantGetCampaignMeasurementRequest } from "../../../../../../_redux/_actions";

export default function Rewards(props) {
     const { id } = useParams();
     const actionDispatch = useDispatch();
     const { campaignMeasurement } = useSelector((state) => ({
          campaignMeasurement:
               state.participantsManagement?.campaignMeasurement || {},
     }));

     // Fetch campaign measurement data when component mounts
     useEffect(() => {
          if (id) {
               console.log("Dispatching with campaign ID:", id);
               actionDispatch(
                    participantGetCampaignMeasurementRequest({
                         campaignId: id,
                    }),
               );
          }
     }, [id, actionDispatch]);

     // Add more detailed logging
     useEffect(() => {
          console.log(
               "Campaign Measurement state updated:",
               campaignMeasurement,
          );
     }, [campaignMeasurement]);

     const [selectedPoint, setSelectedPoint] = useState(null);
     const [selectedVoucher, setSelectedVoucher] = useState(null);
     const [selectedVoucherValue, setSelectedVoucherValue] = useState("");

     const pointsOptions =
          campaignMeasurement?.pointsRewardsList?.map((point) => ({
               value: point.id.toString(),
               label: point.displayName,
          })) || [];

     const voucherOptions =
          campaignMeasurement?.voucherRewardsList?.map((voucher) => ({
               value: voucher.id.toString(),
               label: voucher.displayName,
          })) || [];

     // Handle point selection
     const handlePointSelect = (e) => {
          const pointId = e.value;
          setSelectedPoint(pointId);
     };

     // Handle voucher selection
     // Handle voucher selection
     const handleVoucherSelect = (e) => {
          // Extract the actual value string from the object
          const voucherId = e.value.value;
          setSelectedVoucher(voucherId);
          console.log(`Selected Voucher ID: ${voucherId}`);

          // Added additional logging to check the event object
          console.log("Voucher select event:", e);

          // Find and set the selected voucher value
          const selectedVoucherItem =
               campaignMeasurement?.voucherRewardsList?.find(
                    (voucher) => voucher.id.toString() === voucherId,
               );

          // Added logging for debugging the voucher list
          console.log(
               "Available vouchers:",
               campaignMeasurement?.voucherRewardsList,
          );

          if (selectedVoucherItem) {
               console.log("Selected Voucher Item:", selectedVoucherItem);
               // Convert to string if it's a number to ensure proper state update
               const valueInGbp =
                    selectedVoucherItem.valueInGbp?.toString() || "";
               setSelectedVoucherValue(valueInGbp);
               console.log(
                    `Selected voucher: ${selectedVoucherItem.displayName}, Value: £${valueInGbp}`,
               );
          } else {
               setSelectedVoucherValue("");
               console.log("No matching voucher found for ID:", voucherId);
               console.log("Voucher comparison types:", {
                    voucherId: typeof voucherId,
                    firstVoucherId: campaignMeasurement?.voucherRewardsList?.[0]
                         ?.id
                         ? typeof campaignMeasurement.voucherRewardsList[0].id
                         : "undefined",
               });
          }
     };

     // Handle add point button click
     const handleAddPoint = () => {
          if (selectedPoint) {
               console.log(`Adding point reward with ID: ${selectedPoint}`);
               // Add implementation to add the point to the reward pot configuration
          }
     };

     // Handle add voucher button click
     const handleAddVoucher = () => {
          if (selectedVoucher) {
               console.log(`Adding voucher reward with ID: ${selectedVoucher}`);
               // Add implementation to add the voucher to the reward pot configuration
          }
     };
     // Extract values from campaignMeasurement if it exists
     console.log("Campaign Measurement:", campaignMeasurement);
     const totalBudget = campaignMeasurement?.totalRewardBudget || "2250";
     const issuedPoints = campaignMeasurement?.totalRewardIssued || "1000";
     const unissuedPoints = campaignMeasurement?.totalRewardBalance || "1250";
     const gamePlayTokenCount = campaignMeasurement?.gamePlayTokenCount || "1";

     const options = [
          { value: "value-1", label: "text-1" },
          { value: "value-2", label: "text-2" },
          { value: "value-3", label: "text-3" },
     ];
     const data = [
          {
               label: "Continuous Wining Game Play",
               value: "0",
          },
          {
               label: " Unlucky Game Play ",
               value: "1",
          },
          {
               label: "Shuffle Game Play ",
               value: "2",
          },
     ];

     const areaValidator = (value) => (value ? "" : "Area is required.");

     return (
          <>
               <Grid container spacing={2} sx={{ mt: 2, mb: 6 }}>
                    <Grid item xs={12} lg="4">
                         <div className="sbm-rewards-top-box sbm-rewards-allocated-points">
                              <h3>Total Points Budget</h3>
                              <span>{totalBudget}</span>
                         </div>
                    </Grid>
                    <Grid item xs={12} lg="4">
                         <div className="sbm-rewards-top-box sbm-rewards-utilized-points">
                              <h3>Total Issued Points</h3>
                              <span>{issuedPoints}</span>
                         </div>
                    </Grid>
                    <Grid item xs={12} lg="4">
                         <div className="sbm-rewards-top-box sbm-rewards-remaining-points">
                              <h3>Total Unissued Points</h3>
                              <span>{unissuedPoints}</span>
                         </div>
                    </Grid>
               </Grid>

               <UiInputGroupWr title="Game Play Configuration">
                    <GamePlayConfigurationForm />
                    {/* <RequiredClaimTokenCountForm gamePlayTokenCount={gamePlayTokenCount}/> */}
                    {/* <GameplayWheelConfigurationForm campaignMeasurement={campaignMeasurement}/> */}
                    {/* <GameplayWinningSlotConfigurationForm/> */}
               </UiInputGroupWr>

               <UiInputGroupWr title="Game Play Reward Pot Configuration">
                    <Grid
                         container
                         spacing={2}
                         sx={{ mb: 1 }}
                         className="sba-btn-section-wr"
                    >
                         <Grid item xs={12} lg={4}>
                              <UiTopDropDownList
                                   label="Reward Points"
                                   data={pointsOptions}
                                   handleSelect={handlePointSelect}
                              />
                         </Grid>
                         <Grid item xs={12} lg={2} sx={{ mt: 3 }}>
                              <UiInput placeholder="Qty" />
                         </Grid>

                         <Grid item xs={12} lg={4} sx={{ mt: 2.5 }}>
                              <UiButton
                                   name="Add Point"
                                   variant="contained"
                                   size="small"
                                   onClick={handleAddPoint}
                                   disabled={!selectedPoint}
                              />
                         </Grid>
                    </Grid>
                    <Grid container>
                         <Grid item xs={12} lg={12} sx={{ mb: 2.5 }}>
                              <label className="sb-vouhcer-label">
                                   Point Value:{" "}
                              </label>
                         </Grid>
                    </Grid>
                    <Grid
                         container
                         spacing={2}
                         sx={{ mb: 1 }}
                         className="sba-btn-section-wr"
                    >
                         <Grid item xs={12} lg={4}>
                              <UiTopDropDownList
                                   label="Reward Vouchers"
                                   data={voucherOptions}
                                   handleSelect={(e) => {
                                        console.log("Raw dropdown event:", e);
                                        handleVoucherSelect(e);
                                   }}
                                   value={selectedVoucher || ""}
                              />
                         </Grid>
                         <Grid item xs={12} lg={2} sx={{ mt: 3 }}>
                              <UiInput placeholder="Qty" />
                         </Grid>

                         <Grid item xs={12} lg={4} sx={{ mt: 2.5 }}>
                              <UiButton
                                   name="Add Voucher"
                                   variant="contained"
                                   size="small"
                                   onClick={handleAddVoucher}
                                   disabled={!selectedVoucher}
                              />
                         </Grid>
                    </Grid>
                    <Grid container>
                         <Grid item xs={12} lg={12}>
                              <label className="sb-vouhcer-label">
                                   Voucher Value:{" "}
                                   {selectedVoucherValue
                                        ? `£${selectedVoucherValue}`
                                        : "N/A"}
                              </label>
                         </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                         <Grid item xs={12} lg={12}>
                              <GamePlayRewardPotConfiguration
                                   allocatedRewards={
                                        campaignMeasurement?.allocatedRewards ||
                                        []
                                   }
                              />
                         </Grid>
                    </Grid>
               </UiInputGroupWr>
          </>
     );
}
